/**============================================================
*   [Class] ブログ：記事スライダー
============================================================*/
export default class ArchiveSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-'+ this.swiperKey);

    let swiperSlides = this.swiperSlide.getElementsByClassName('swiper-slide');
    let slidable = swiperSlides.length > this.swiperSlide.clientWidth/340;

    this.initSwiper = () => {
      this.mySwiper = new Swiper(this.swiperSlide, {
        spaceBetween: 40,
        slidesPerView: 'auto',
        loop: slidable,
        navigation: {
          nextEl: '.swiper-'+ key + '+ .swiper-button-prev + .swiper-button-next',
          prevEl: '.swiper-'+ key + '+ .swiper-button-prev',
        },
        watchOverflow: !slidable,
      });
    };

    this.mySwiper = null;
    this.checkBreakpoint = (e) => {
      if (e.matches) {
        if(this.mySwiper){
          this.mySwiper.destroy(false, true);
        }
      } else {
        this.initSwiper();
      }
    }

    this.mediaQuery = window.matchMedia('(max-width: 767px)');
    this.mediaQuery.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQuery);

  }
}
